export type SupportedMultiLanguage = 'zh-Hans' | 'zh-Hant' | 'ms' | 'in' | 'ar' | 'en' | 'tl' | 'vi' | 'th' | 'tr'

export type MultiLanguageType = {
  [key: string]: string
}

export const initMultiLanguage: MultiLanguageType = {
  en: '',
  'zh-Hans': '',
  ms: '',
  in: '',
  ar: '',
  'zh-Hant': '',
  tl: '', // 菲律宾语
  vi: '', // 越南语
  th: '', // 泰语
  tr: '' // 土耳其语
}

// 根据initMultiLanguage补充缺少的字段(英文值暂时为的传入值)
export const mergeLanguageObject = (params: any, val?: any): MultiLanguageType => {
  const merges: MultiLanguageType = { ...initMultiLanguage }

  for (const key in params) {
    merges[key] = params[key]
  }

  if (val) {
    merges.en = val as string
  }

  // 根据 initKeys 数组的顺序重新排序属性
  const orderedMerges: MultiLanguageType = {}
  const initKeys = Object.keys(initMultiLanguage)
  for (let i = 0; i < initKeys.length; i++) {
    const key = initKeys[i]
    orderedMerges[key] = merges[key]
  }
  return orderedMerges
}
